import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectPagesLegacyRoute: InvariantJiraRoute = {
	name: 'project-pages-legacy',
	path: '/projects/:projectKey',
	query: ['selectedItem=com.atlassian.jira.jira-projects-plugin:project-pages-page'],
};
